<template>
  <div v-if="doesUserHavePendingDocumentation" class="card-pending-documentation">
    <div class="d-flex justify-content-between align-items-center">
      <h3>{{ $t("components.cardPendingDocumentation.title") }}</h3>
    </div>
    <div class="py-2 mt-2">
      {{ $t("components.cardPendingDocumentation.description") }}
    </div>
    <div class="mt-2 feature d-flex flex-row">
      <div class="d-flex flex-column justify-content-center align-items-center" style="width:15%">
        <img class="icon-danger align-self-center" src="@/assets/img/icons/danger.svg"></img>
      </div>
      <div class="d-flex flex-column" style="width:85%">
        <span style="font-weight: 600; font-size: 0.8rem;">{{ $t("components.cardPendingDocumentation.identity_verification") }}</span>
        <StatusTag :status="identityValidationDocumentationStatus"/>
      </div>
    </div>
    <div class="mt-2 feature d-flex flex-row">
      <div class="d-flex flex-column justify-content-center align-items-center" style="width:15%">
        <img class="icon-danger align-self-center" src="@/assets/img/icons/danger.svg"></img>
      </div>
      <div class="d-flex flex-column" style="width:85%">
        <span style="font-weight: 600; font-size: 0.8rem;">{{ $t("components.cardPendingDocumentation.financial_data") }}</span>
        <StatusTag :status="financialDocumentationStatus"/>
      </div>
    </div>
    <div class="d-flex flex-row">
      <button class="w-100" @click="sendDocumentation">
        {{ $t("components.cardPendingDocumentation.send_documentation") }}
      </button>
    </div>
  </div>
</template>

<script>
import DocumentationStatusService from '@/services/resources/DocumentationStatusService';
import StatusTag from '@/components/shared/StatusTag';

const serviceDocumentationStatus = DocumentationStatusService.build();

export default {
  name: 'CardPendingDocumentation',
  components: {
    StatusTag
  },
  data() {
    return {
      doesUserHavePendingDocumentation: false,
      identityValidationDocumentationStatus: 'PENDING',
      financialDocumentationStatus: 'PENDING'
    }
  },
  methods: {
    
    sendDocumentation() {
      this.$router.push('/minha-conta');
    },
    fetchDocumentationStatus() {
      serviceDocumentationStatus
        .search()
        .then((response) => {
          this.doesUserHavePendingDocumentation = response.doesUserHavePendingDocumentation;
          this.identityValidationDocumentationStatus = response.identityValidationDocumentationStatus;
          this.financialDocumentationStatus = response.financialDocumentationStatus;
        })
        .catch((err) => console.error(err))
    }
  },
  created() {
    this.fetchDocumentationStatus();
  }
}
</script>

<style lang="scss" scoped>
.card-pending-documentation {
  width: 400px;
  background: #ffffff;
  border: 1px solid #f7f7f7;
  border-radius: 8px;
  padding: 50px;
  
  h3 {
    font-size: 16px;
    font-weight: 600;
  }

  .feature {
    background: #F9FAFB;
    padding: 12px;
    border-radius: 4px;
  }

  button {
    margin-top: 20px;
    padding: 12px;
    background: #2a63ab;
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    
    &:hover {
      background: darken(#2a63ab, 5%);
    }
  }
  .icon-danger{
    width: 18px;
  }
}

@media screen and (max-width: 768px) {
  .card-pending-documentation {
    width: 100%;
    padding: 30px 20px;
  }
}
</style>
